import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import SignupView from '@/views/SignupView.vue'
import AppointmentView from '@/views/AppointmentView.vue'
import categorieView from '@/views/CategorieView.vue'
import BookingView from '@/views/BookingView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/rendez-vous',
    name: 'appointment',
    component: AppointmentView,
    meta: { requiresAuth: true }
  },
  {
    path: '/booking',
    name: 'booking',
    component: BookingView
  },
  {
    path: '/signup',
    name: 'signup',
    component: SignupView
  },
  {
    path: '/categorie',
    name: 'categorie',
    component: categorieView
  },
  {
    path: '/services/:categorie',
    name: 'ServiceCategory',
    component: () => import('@/views/ServiceCategory.vue'),
  },
  {
    path: '/about',
    name: 'about',
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// 🛡️ Guard de navigation global pour vérifier l'authentification client
router.beforeEach(async (to, from, next) => {
  if (to.meta.requiresAuth) {
    const token = localStorage.getItem('clientToken')

    if (!token) {
      return next({ name: 'signup' })
    }

    try {
      const response = await fetch('http://localhost:3000/api/clients/verify-token', {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })

      if (!response.ok) {
        throw new Error('Token invalide')
      }

      next() // ✅ Token valide
    } catch (error) {
      console.error('Erreur de vérification de token :', error)
      localStorage.removeItem('clientToken') // 🧹 Nettoyage du token
      next({ name: 'signup' }) // 🔁 Redirection
    }
  } else {
    next() // ✅ Route publique
  }
})

export default router
